document.addEventListener('click', function (e) {
  if (window.matchMedia('(max-width: 749px)').matches) {
    const zoomTrigger = e.target.closest(
      '.product-media-container--zoomable, .product-media-container__zoom-button'
    );
    if (zoomTrigger) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }
}, true);